const target = '.anchor-link a';
const offset = 80;
const duration = 500;
jQuery(document).on('ready', function () {
    jQuery(target).click(function () {
        var href = jQuery(this).attr('href');
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(href).offset().top - offset
        }, duration);
    });
});
